<template>
    <div class="px-sm-0 px-2">
        <v-btn block :loading="loading" :disabled="loading" color="primary" depressed tile large @click="submit($event)">Dokončit objednávku</v-btn>
        <p class="caption mt-2">Dokončením objednávky potvrzujete, že jste se seznámil s  <a
                target="_blank"
                href="/pdf/VOP_sbirka_pro_Ukrajinu_ZooPraha_20220302.pdf"
                @click.stop
        >Obchodními podmínkami</a>.</p>
        <v-checkbox v-model="form.marketingAgreement" :rules="[rules.required]">
            <template v-slot:label>
                <div>
                    Souhlasím se zpracováním osobních údajů. Naše pravidla Ochrany osobních údajů najdete
                    <template>
                        <a
                                target="_blank"
                                href="/pdf/GDPR_Cookies__sbirka_pro_Ukrajinu_ZooPraha_20220302.pdf"
                                @click.stop
                        >zde</a>
                    </template>
                </div>
            </template>
        </v-checkbox>
    </div>
</template>

<script>
    export default {
        name: 'PlaceOrder',
        props: ['form', 'loading'],
        data () {
            return {
                rules: window.validationRules.getRules()
            }
        },
        methods: {
            submit(event) {
                this.$emit('submit', event);
            }
        }
    }
</script>
